import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { closeFilterDropdown, toggleFilterDropdown } from '../../../../store/slice/filter-slice';
import Button from '../../Common/Button';
import FiltersSetup from './FiltersSetup';
import filters_icon from '../../../../assets/img/svg/buttons/filter.svg';
import { FilterType } from '../../../../enum/FilterType';
import { useAppSelector } from '../../../../hook/useAppSelector';

const CustomFilter = () => {
  const dispatch = useAppDispatch();

  const menuRef = useRef<HTMLDivElement>(null);

  const openFilters = () => {
    dispatch(toggleFilterDropdown());
  };

  const filters = useAppSelector((state) => state.globalFilters);
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const openFilterDropDown = useAppSelector((state) => state.filters.openFilterDropDown);

  const shouldListenClose = !(
    filterType === FilterType.CASH_REGISTER_FILTERS &&
    (!filters.Group || filters.Group.length === 0)
  );

  useEffect(() => {
    if (!shouldListenClose) return;

    const handleClose = () => {
      if (menuRef.current && document.activeElement && menuRef.current.contains(document.activeElement)) {
        return;
      }

      dispatch(closeFilterDropdown());
    };

    const handleClickOutside = (e: Event) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        handleClose();
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('pointerdown', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, [shouldListenClose, dispatch]);

  return (
    <div data-pw="filters" className="filter_button_wrapper">
      <div ref={menuRef} className="filter_button_container">
        <Button
          icon={filters_icon}
          onClick={openFilters}
          variant={`${openFilterDropDown ? 'filled' : ''}`}
          className="filter_button"
        />
        <FiltersSetup />
      </div>
    </div>
  );
};
export default CustomFilter;
